import { useBetSlice } from '../store/slices/bets/selectors';
import { useConfigSlice } from '../store/slices/config/selectors';

export const useShouldStayConnected = (): boolean => {
  const stayTillEnd = useConfigSlice.compliance()?.waitResultBeforeLeave;
  const hasTotalBet = useBetSlice.hasTotalBet();
  return !!(stayTillEnd && hasTotalBet);
};
